module.exports = __webpack_public_path__ + "img/1.95353a6f.png";